module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cFEDG"))).then(() => parcelRequire('d0iPb'));